<template>
  <div class="lald-case">
    <div class="content">
      <h1 class="lald-case__title">Клинический случай ДЛКЛ</h1>
    </div>
    <Breadcrumbs
      :pages="[
        {
          name: 'Клинический случай',
        },
      ]"
    />

    <Steps :key="key" @repeat="repeat" />
  </div>
</template>

<script>
import Breadcrumbs from "@/components/pageComponents/Breadcrumbs.vue";
import Steps from "../components/laldICC/Steps.vue";
export default {
  name: "LaldClinicalCase",
  components: {
    Breadcrumbs,
    Steps,
  },
  data: () => ({
    key: 0,
  }),
  methods: {
    repeat() {
      this.key++;
    },
  },
};
</script>

<style lang="scss" scoped>
.lald-case {
  padding-top: 32px;

  &__title {
    font-family: "Roboto Slab", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 36px;
    line-height: 47px;
    color: #3c4242;
  }
}
</style>